import GpuHub from "./rent.page";

export default GpuHub;
